export default function Details({ device, calcResultValues, consumptionValues, calcPayment, unit }) {
  return (
    <>
      <div class="counter-form-section__field-wrap" style={{ marginTop: '0px' }}>
        <div class="testimony-counter-form-section__testimony-title" style={{ color: '#FF7819' }}>
          ИТОГО
        </div>
      </div>
      <div class="counter-form-section__field-wrap" style={{ marginTop: '0px' }}>
        <div class="counter-form-section__testimony-field">
          <div class="counter-form-section__testimony-value">
            <div class="counter-form-section__testimony-value-line">
              <div class="counter-form-section__testimony-count"
                dangerouslySetInnerHTML={{ __html: ('Расход, ' + unit) }}
              />
            </div>
            <div class="counter-form-section__testimony-value-line">
              <div class="counter-form-section__testimony-count"
                data-entity="meter-reading-consumption">
                {consumptionValues[device.number] || '-'}
              </div>
            </div>
          </div>
        </div>
        <div class="counter-form-section__testimony-field">
          <div class="counter-form-section__testimony-value">
            <div class="counter-form-section__testimony-value-line">
              <div class="counter-form-section__testimony-count">Стоимость по переданным показаниям</div>
            </div>
            <div class="counter-form-section__testimony-value-line">
              <div class="counter-form-section__testimony-count">
                <span data-entity="meter-reading-cost">{calcPayment[device.number] || '-'}</span> руб.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}